const revenueBySales = (revenues: any) => {
  let j,
    o,
    n,
    d,
    l,
    val,
    rep,
    fle = {};

  revenues.forEach((revenue: any) => {
    if (revenue.analysis === "J") {
      j =
        revenue === undefined
          ? {
              name: "J",
              net: 0,
              profit: 0,
              list: [],
            }
          : {
              name: "J",
              net: revenue.net_sale,
              profit: revenue.retail,
              list: revenue.list,
            };
    }
    if (revenue.analysis === "O") {
      o =
        revenue === undefined
          ? {
              name: "O",
              net: 0,
              profit: 0,
              list: [],
            }
          : {
              name: "O",
              net: revenue.net_sale,
              profit: revenue.retail,
              list: revenue.list,
            };
    }
    if (revenue.analysis === "N") {
      n =
        revenue === undefined
          ? {
              name: "N",
              net: 0,
              profit: 0,
              list: [],
            }
          : {
              name: "N",
              net: revenue.net_sale,
              profit: revenue.retail,
              list: revenue.list,
            };
    }
    if (revenue.analysis === "D") {
      d =
        revenue === undefined
          ? {
              name: "D",
              net: 0,
              profit: 0,
              list: [],
            }
          : {
              name: "D",
              net: revenue.net_sale,
              profit: revenue.retail,
              list: revenue.list,
            };
    }
    if (revenue.analysis === "L") {
      l =
        revenue === undefined
          ? {
              name: "L",
              net: 0,
              profit: 0,
              list: [],
            }
          : {
              name: "L",
              net: revenue.net_sale,
              profit: revenue.retail,
              list: revenue.list,
            };
    }
    if (revenue.analysis === "V") {
      val =
        revenue === undefined
          ? {
              name: "Value +",
              net: 0,
              profit: 0,
              list: [],
            }
          : {
              name: "Value +",
              net: revenue.net_sale,
              profit: revenue.retail,
              list: revenue.list,
            };
    }
    if (revenue.analysis === "S") {
      rep =
        revenue === undefined
          ? {
              name: "Repair Shop",
              net: 0,
              profit: 0,
              list: [],
            }
          : {
              name: "Repair Shop",
              net: revenue.net_sale,
              profit: revenue.retail,
              list: revenue.list,
            };
    }
    if (revenue.analysis === "F") {
      fle =
        revenue === undefined
          ? {
              name: "Fleet",
              net: 0,
              profit: 0,
              list: [],
            }
          : {
              name: "Fleet",
              net: revenue.net_sale,
              profit: revenue.retail,
              list: revenue.list,
            };
    }
  });

  const data = [j, o, n, d, l];

  return data;
};

export default revenueBySales;
